/*
 * HOW DO I USE THIS?
 * 1. Make a new entry into the cities array (google values for lat lng)
 * 2. Set slugs appropriately according to the pattern of exising cities
 * 3. Find a good city image and upload it to S3 dev / prod buckets (must be uploaded as webp)
 * 4. Make a blurhash for the webp image and set it in the array (google image blurhash generator tool)
 * 5. Make sure the city has the right placeid from google maps
 *      https://developers.google.com/maps/documentation/places/web-service/place-id
 *
 * One of us will eventually get around to automating this process again in the future, but I'm really not feeling it rn - Andrew
 */

import { env } from "~/env.mjs";

export const cities = [
    {
        city: "Algiers",
        country: "Algeria",
        cityLong: "Algiers, Algeria",
        citySlug: "algiers-algeria",
        lat: 36.753768,
        lng: 3.0587561,
        timezone: "Africa/Algiers",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UbB;hGWYM{jtKnRjadj[R5n#ayjsVqs.kBWV",
        googleMapsPlaceId: "ChIJn2Xqd2myjxIRSW-jOC0QMUI",
    },
    {
        city: "Amsterdam",
        country: "Netherlands",
        cityLong: "Amsterdam, Netherlands",
        citySlug: "amsterdam-netherlands",
        lat: 52.3675734,
        lng: 4.9041389,
        timezone: "Europe/Amsterdam",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UcJbHh9F8_S4~qRikCRi%hWUn$NGS6xuogax",
        googleMapsPlaceId: "ChIJVXealLU_xkcRja_At0z9AGY",
    },
    {
        city: "Andorra la Vella",
        country: "Andorra",
        cityLong: "Andorra la Vella, Andorra",
        citySlug: "andorra-la-vella-andorra",
        lat: 42.50631740000001,
        lng: 1.5218355,
        timezone: "Europe/Andorra",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UJA^:lMz9aRkIzM{%2xu?dWASdRl%#Mzt7s;",
        googleMapsPlaceId: "ChIJC_slSiv1pRIRgHKZkXCUAAo",
    },
    {
        city: "Ankara",
        country: "Turkey",
        cityLong: "Ankara, Turkey",
        citySlug: "ankara-turkey",
        lat: 39.9333635,
        lng: 32.8597419,
        timezone: "Europe/Istanbul",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U]H{NYt2V@WB.At6oJoeE2ogofofV@WBa|WV",
        googleMapsPlaceId: "ChIJsS1zINVH0xQRjSuEwLBX3As",
    },
    {
        city: "Athens",
        country: "Greece",
        cityLong: "Athens, Greece",
        citySlug: "athens-greece",
        lat: 37.9838096,
        lng: 23.7275388,
        timezone: "Europe/Athens",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UXHd:6M|xaWB_NRjflayEmf5R+fk4=t6WBoe",
        googleMapsPlaceId: "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
    },
    {
        city: "Barcelona",
        country: "Spain",
        cityLong: "Barcelona, Spain",
        citySlug: "barcelona-spain",
        lat: 41.3873974,
        lng: 2.168568,
        timezone: "Europe/Madrid",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UIE.LkE%t7WV_Nf+ofa{yExafkWV%gt6s:oL",
        googleMapsPlaceId: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
    },
    {
        city: "Bay Area",
        country: "USA",
        cityLong: "Bay Area, USA",
        citySlug: "bay-area-usa",
        lat: 37.7749295,
        lng: -122.4194155,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "L1FOcW|.0p%N0HK$bcmk0504n0^*",
        googleMapsPlaceId: "ChIJtdeIpqODhYARqR9GV4QbiYw",
    },
    {
        city: "Belgrade",
        country: "Serbia",
        cityLong: "Belgrade, Serbia",
        citySlug: "belgrade-serbia",
        lat: 44.8125449,
        lng: 20.46123,
        timezone: "Europe/Belgrade",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UrHM4Yofofog?wt7V@j[tRaxj[WBkCV@ofof",
        googleMapsPlaceId: "ChIJvT-116N6WkcR5H4X8lxkuB0",
    },
    {
        city: "Berlin",
        country: "Germany",
        cityLong: "Berlin, Germany",
        citySlug: "berlin-germany",
        lat: 52.52000659999999,
        lng: 13.404954,
        timezone: "Europe/Berlin",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UqJas7xuWAWX?wxYs-bIElsns:j[IVWVoLj[",
        googleMapsPlaceId: "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
    },
    {
        city: "Bern",
        country: "Switzerland",
        cityLong: "Bern, Switzerland",
        citySlug: "bern-switzerland",
        lat: 46.9479739,
        lng: 7.4474468,
        timezone: "Europe/Zurich",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UVEgN*N2v#o#-?x[Xmn$P;tlV@V]TzRjoebb",
        googleMapsPlaceId: "ChIJdxs61MA5jkcRmmVXBP5fVcs",
    },
    {
        city: "Bristol",
        country: "UK",
        cityLong: "Bristol, UK",
        citySlug: "bristol-uk",
        lat: 51.454513,
        lng: -2.58791,
        timezone: "Europe/London",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U-IFMNWBj]ay_Nj[ayj[j[fkayayM{jtj[j[",
        googleMapsPlaceId: "ChIJYdizgWaDcUgRH9eaSy6y5I4",
    },
    {
        city: "Brussels",
        country: "Belgium",
        cityLong: "Brussels, Belgium",
        citySlug: "brussels-belgium",
        lat: 50.8476424,
        lng: 4.3571696,
        timezone: "Europe/Brussels",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UmJbBX.8D*Rj_4tSM{WBa}RiRjogxtadj@oz",
        googleMapsPlaceId: "ChIJZ2jHc-2kw0cRpwJzeGY6i8E",
    },
    {
        city: "Bucharest",
        country: "Romania",
        cityLong: "Bucharest, Romania",
        citySlug: "bucharest-romania",
        lat: 44.4267674,
        lng: 26.1025384,
        timezone: "Europe/Bucharest",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UYEo_cOIafac%jSlaxn}EUR;oIs,NMRos+ax",
        googleMapsPlaceId: "ChIJT608vzr5sUARKKacfOMyBqw",
    },
    {
        city: "Budapest",
        country: "Hungary",
        cityLong: "Budapest, Hungary",
        citySlug: "budapest-hungary",
        lat: 47.497912,
        lng: 19.040235,
        timezone: "Europe/Budapest",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UsIF0xbckCRj?wslflogkXsljFjr%1S5j?ay",
        googleMapsPlaceId: "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
    },
    {
        city: "Buffalo",
        country: "USA",
        cityLong: "Buffalo, NY",
        citySlug: "buffalo-ny",
        lat: 42.886446,
        lng: -78.878369,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "LqDcnJWYR%axpfj[bFjY9vjsj?js",
        googleMapsPlaceId: "ChIJoeXfUmES04kRcYEfGKUEI5g",
    },
    {
        city: "Cairo",
        country: "Egypt",
        cityLong: "Cairo, Egypt",
        citySlug: "cairo-egypt",
        lat: 30.0444196,
        lng: 31.2357116,
        timezone: "Africa/Cairo",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UfKd9[W=j[WV_NxaWBof^+WVayayE2ofoLj[",
        googleMapsPlaceId: "ChIJ674hC6Y_WBQRujtC6Jay33k",
    },
    {
        city: "Cambridge",
        country: "UK",
        cityLong: "Cambridge, UK",
        citySlug: "cambridge-uk",
        lat: 52.1950788,
        lng: 0.1312729,
        timezone: "Europe/London",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UoIEhaWBRjay?wWVjYoLxuWVoJoeM{j[fPj@",
        googleMapsPlaceId: "ChIJLQEq84ld2EcRIT1eo-Ego2M",
    },
    {
        city: "Cape Town",
        country: "South Africa",
        cityLong: "Cape Town, South Africa",
        citySlug: "cape-town-south-africa",
        lat: -33.9248685,
        lng: 18.4240553,
        timezone: "Africa/Johannesburg",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UbJuP]0KoLM{|rM{WqRjT}s.V@j[.ToeRPs:",
        googleMapsPlaceId: "ChIJ1-4miA9QzB0Rh6ooKPzhf2g",
    },
    {
        city: "Copenhagen",
        country: "Denmark",
        cityLong: "Copenhagen, Denmark",
        citySlug: "copenhagen-denmark",
        lat: 55.6760968,
        lng: 12.5683371,
        timezone: "Europe/Copenhagen",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UiEWUabwS5s.yZbIWAWVAdoLaKW=Neadaej[",
        googleMapsPlaceId: "ChIJIz2AXDxTUkYRuGeU5t1-3QQ",
    },
    {
        city: "Dublin",
        country: "Ireland",
        cityLong: "Dublin, Ireland",
        citySlug: "dublin-ireland",
        lat: 53.3498053,
        lng: -6.2603097,
        timezone: "Europe/Dublin",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UiF~:PMxD%xu_NNGWAoLEMWDxuRj9Zt7s:WB",
        googleMapsPlaceId: "ChIJL6wn6oAOZ0gRoHExl6nHAAo",
    },
    {
        city: "Helsinki",
        country: "Finland",
        cityLong: "Helsinki, Finland",
        citySlug: "helsinki-finland",
        lat: 60.16985569999999,
        lng: 24.938379,
        timezone: "Europe/Helsinki",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UHFr|w%fENR+*0nhnij[JWM|xBoJ+@bcWoWC",
        googleMapsPlaceId: "ChIJkQYhlscLkkYRY_fiO4S9Ts0",
    },
    {
        city: "Johannesburg",
        country: "South Africa",
        cityLong: "Johannesburg, South Africa",
        citySlug: "johannesburg-south-africa",
        lat: -26.2041028,
        lng: 28.0473051,
        timezone: "Africa/Johannesburg",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UVFrLktQNIWC~StQNKj[-oR*RnWBM~RkRkbb",
        googleMapsPlaceId: "ChIJUWpA8GgMlR4RQUDTsdnJiiM",
    },
    {
        city: "Lisbon",
        country: "Portugal",
        cityLong: "Lisbon, Portugal",
        citySlug: "lisbon-portugal",
        lat: 38.7222524,
        lng: -9.1393366,
        timezone: "Europe/Lisbon",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UrL;HWaKaeWC.Tj[kCkCS%s.e.W;WXofayn$",
        googleMapsPlaceId: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
    },
    {
        city: "London",
        country: "UK",
        cityLong: "London, UK",
        citySlug: "london-uk",
        lat: 51.5072178,
        lng: -0.1275862,
        timezone: "Europe/London",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UpH2NDoJaekC~WoLfkjs-:bIWBax%MWBayfl",
        googleMapsPlaceId: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
    },
    {
        city: "Luanda",
        country: "Angola",
        cityLong: "Luanda, Angola",
        citySlug: "luanda-angola",
        lat: -8.8146556,
        lng: 13.2301756,
        timezone: "Africa/Luanda",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UxPGd8bHRie.?wWCaybHRkWVbHofRif8ofWB",
        googleMapsPlaceId: "ChIJfSyN3FzxURoRklrMXlwcDIU",
    },
    {
        city: "Luxembourg",
        country: "Luxembourg",
        cityLong: "Luxembourg, Luxembourg",
        citySlug: "luxembourg-luxembourg",
        lat: 49.815273,
        lng: 6.129582999999999,
        timezone: "Europe/Luxembourg",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UiE3C#xZkCRj_N%1S4ae?bt7WWjYx]a#WVoK",
        googleMapsPlaceId: "ChIJRyEhyrlFlUcR75LTAvZg22Q",
    },
    {
        city: "Madrid",
        country: "Spain",
        cityLong: "Madrid, Spain",
        citySlug: "madrid-spain",
        lat: 40.4167754,
        lng: -3.7037902,
        timezone: "Europe/Madrid",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UaJQD:tl9we-~qb^r?ni_2o|kCWV-=t7R+af",
        googleMapsPlaceId: "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",
    },
    {
        city: "Manchester",
        country: "UK",
        cityLong: "Manchester, UK",
        citySlug: "manchester-uk",
        lat: 53.4807593,
        lng: -2.2426305,
        timezone: "Europe/London",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UtJ*SKn%jZt7_NWBxat7%hofayjZxtWBayWB",
        googleMapsPlaceId: "ChIJ2_UmUkxNekgRqmv-BDgUvtk",
    },
    {
        city: "Minsk",
        country: "Belarus",
        cityLong: "Minsk, Belarus",
        citySlug: "minsk-belarus",
        lat: 53.9006011,
        lng: 27.558972,
        timezone: "Europe/Minsk",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UhEpNGxZNGa}ysofs.jsFza}a}fkM|WCayaz",
        googleMapsPlaceId: "ChIJ02oeW9PP20YR2XC13VO4YQs",
    },
    {
        city: "Monaco",
        country: "Monaco",
        cityLong: "Monaco, Monaco",
        citySlug: "monaco-monaco",
        lat: 43.73841760000001,
        lng: 7.424615799999999,
        timezone: "Europe/Monaco",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UcFsY;Z~i^ayysROWBofXTJVR*V?JUxujYoK",
        googleMapsPlaceId: "ChIJMYU_e2_CzRIR_JzEOkx493Q",
    },
    {
        city: "Munich",
        country: "Germany",
        cityLong: "Munich, Germany",
        citySlug: "munich-germany",
        lat: 48.1351253,
        lng: 11.5819806,
        timezone: "Europe/Berlin",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U8G[7o}Q4os=*I==D%V{1ROUVsRQ07NM%Kt6",
        googleMapsPlaceId: "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",
    },
    {
        city: "Nairobi",
        country: "Kenya",
        cityLong: "Nairobi, Kenya",
        citySlug: "nairobi-kenya",
        lat: -1.2920659,
        lng: 36.8219462,
        timezone: "Africa/Nairobi",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U5AvCU0$9EoxT#5mr;R%00=r-pRj0e=]b_xG",
        googleMapsPlaceId: "ChIJp0lN2HIRLxgRTJKXslQCz_c",
    },
    {
        city: "Nicosia",
        country: "Cyprus",
        cityLong: "Nicosia, Cyprus",
        citySlug: "nicosia-cyprus",
        lat: 35.1855659,
        lng: 33.38227639999999,
        timezone: "Asia/Nicosia",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UmI~0.oLM|j[_4oLofay%haxoKa#x^aej?oL",
        googleMapsPlaceId: "ChIJVU1JymcX3hQRpcARA5ykXls",
    },
    {
        city: "Oslo",
        country: "Norway",
        cityLong: "Oslo, Norway",
        citySlug: "oslo-norway",
        lat: 59.9138688,
        lng: 10.7522454,
        timezone: "Europe/Oslo",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UiB|zPx]j]of-@oyf5fkS8WYaeWCV]WXayju",
        googleMapsPlaceId: "ChIJOfBn8mFuQUYRmh4j019gkn4",
    },
    {
        city: "Paris",
        country: "France",
        cityLong: "Paris, France",
        citySlug: "paris",
        lat: 48.856614,
        lng: 2.3522219,
        timezone: "Europe/Paris",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UUG9{[tRRjen5eR-ofbFDNWAWBog%Nj[ofV@",
        googleMapsPlaceId: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
    },
    {
        city: "Prague",
        country: "Czech Republic",
        cityLong: "Prague, Czech Republic",
        citySlug: "prague-czech-republic",
        lat: 50.0755381,
        lng: 14.4378005,
        timezone: "Europe/Prague",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UcLpKy9bIpWVC8$*xtRk~WRjofoL^+axRkay",
        googleMapsPlaceId: "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
    },
    {
        city: "Rabat",
        country: "Morocco",
        cityLong: "Rabat, Morocco",
        citySlug: "rabat-morocco",
        lat: 33.9715904,
        lng: -6.8498129,
        timezone: "Africa/Casablanca",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UVHCQ7-;oengCA-;xabF-9RkoMoz9FM{WBjb",
        googleMapsPlaceId: "ChIJwcVQH4drpw0RawcIdO1GyXo",
    },
    {
        city: "Reykjavik",
        country: "Iceland",
        cityLong: "Reykjavik, Iceland",
        citySlug: "reykjavik-iceland",
        lat: 64.1469868,
        lng: -21.9407552,
        timezone: "Atlantic/Reykjavik",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UmIrT#ofRjt6~qayayWB.7WBfkay-;ofayof",
        googleMapsPlaceId: "ChIJw-3c7rl01kgRcWDSMKIskew",
    },
    {
        city: "Riga",
        country: "Latvia",
        cityLong: "Riga, Latvia",
        citySlug: "riga-latvia",
        lat: 56.9676941,
        lng: 24.1056221,
        timezone: "Europe/Riga",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U#D18PogM{oc%%a#V@oeRQR-j@oeR5RnkCoK",
        googleMapsPlaceId: "ChIJ7T0H5bDP7kYRMP7yaM3PAAQ",
    },
    {
        city: "Rome",
        country: "Italy",
        cityLong: "Rome, Italy",
        citySlug: "rome-italy",
        lat: 41.9027835,
        lng: 12.4963655,
        timezone: "Europe/Rome",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U|Jbmhj[azj[?wj[WUj[M|WCjbazIUWBoJay",
        googleMapsPlaceId: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
    },
    {
        city: "Sarajevo",
        country: "Bosnia and Herzegovina",
        cityLong: "Sarajevo, Bosnia and Herzegovina",
        citySlug: "sarajevo-bosnia-and-herzegovina",
        lat: 43.8562586,
        lng: 18.4130763,
        timezone: "Europe/Sarajevo",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UoFP$@xCo#bHL4s.bcfkGIS4V@j[Rmbbnhj@",
        googleMapsPlaceId: "ChIJ0Ztx7bHLWEcRPrOH3qbNLlY",
    },
    {
        city: "Sofia",
        country: "Bulgaria",
        cityLong: "Sofia, Bulgaria",
        citySlug: "sofia-bulgaria",
        lat: 42.6977082,
        lng: 23.3218675,
        timezone: "Europe/Sofia",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UpG+%YRjW@M|%%t6j[ofIqofadogj=axafWA",
        googleMapsPlaceId: "ChIJ9Xsxy4KGqkARYF6_aRKgAAQ",
    },
    {
        city: "Stockholm",
        country: "Sweden",
        cityLong: "Stockholm, Sweden",
        citySlug: "stockholm-sweden",
        lat: 59.32932349999999,
        lng: 18.0685808,
        timezone: "Europe/Stockholm",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U=HDgGkWWrjsLgjFo0bHE+W;ayjZwHj]afjZ",
        googleMapsPlaceId: "ChIJywtkGTF2X0YRZnedZ9MnDag",
    },
    {
        city: "Tirana",
        country: "Albania",
        cityLong: "Tirana, Albania",
        citySlug: "tirana-albania",
        lat: 41.3275459,
        lng: 19.8186982,
        timezone: "Europe/Tirane",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UwC@mlIqt7WC%%NHoLWVbKn$WAayM{xEWBaz",
        googleMapsPlaceId: "ChIJ28X6cAQxUBMRIDdlEK-SAAQ",
    },
    {
        city: "Torino",
        country: "Italy",
        cityLong: "Torino, Italy",
        citySlug: "torino-italy",
        lat: 45.0703393,
        lng: 7.686864,
        timezone: "Europe/Rome",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U~H.]5WBWBjt?wjsa}a|W=ofj[j[M{j[aya|",
        googleMapsPlaceId: "ChIJ31ztwwxtiEcR4JQ8R33mBQQ",
    },
    {
        city: "Vienna",
        country: "Austria",
        cityLong: "Vienna, Austria",
        citySlug: "vienna-austria",
        lat: 48.2081664,
        lng: 16.3718643,
        timezone: "Europe/Vienna",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UlFP1;oeWBj]_4bHWVj[XoWXf6az9woLoLay",
        googleMapsPlaceId: "ChIJn8o2UZ4HbUcRRluiUYrlwv0",
    },
    {
        city: "Warsaw",
        country: "Poland",
        cityLong: "Warsaw, Poland",
        citySlug: "warsaw-poland",
        lat: 52.2296756,
        lng: 21.0122287,
        timezone: "Europe/Warsaw",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "U7CF;e_20#oI029J$Kr;|,i]kYo#X:%f%LJE",
        googleMapsPlaceId: "ChIJAZ-GmmbMHkcR_NPqiCq-8HI",
    },
    {
        city: "Zagreb",
        country: "Croatia",
        cityLong: "Zagreb, Croatia",
        citySlug: "zagreb-croatia",
        lat: 45.8150108,
        lng: 15.981919,
        timezone: "Europe/Zagreb",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "USGbhstmn%j]?w%MWBkCTLxGRjfk%MV@WAof",
        googleMapsPlaceId: "ChIJOcwCyZLWZUcRisL7KJYkRTo",
    },
    {
        city: "Zurich",
        country: "Switzerland",
        cityLong: "Zurich, Switzerland",
        citySlug: "zurich-switzerland",
        lat: 47.3768866,
        lng: 8.541694,
        timezone: "Europe/Zurich",
        region: "Africa & EU",
        regionSlug: "africa-eu",
        blurHash: "UmH-}hNbV@s._NsmjZj[.8s.kCWXo~j[ofae",
        googleMapsPlaceId: "ChIJGaK-SZcLkEcRA9wf5_GNbuY",
    },
    {
        city: "Abu Dhabi",
        country: "UAE",
        cityLong: "Abu Dhabi, UAE",
        citySlug: "abu-dhabi-uae",
        lat: 24.453884,
        lng: 54.3773438,
        timezone: "Asia/Dubai",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UWD9eoozaKxapy%1Rjf+%gS5WAWBo#s:aeRj",
        googleMapsPlaceId: "ChIJufI-cg9EXj4RCBGXQZMuzMc",
    },
    {
        city: "Auckland",
        country: "New Zealand",
        cityLong: "Auckland, New Zealand",
        citySlug: "auckland-new-zealand",
        lat: -36.85088270000001,
        lng: 174.7644881,
        timezone: "Pacific/Auckland",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UfF%9,I:s:a}?^RkbHay5Uf8afa}9boLoLjZ",
        googleMapsPlaceId: "ChIJ--acWvtHDW0RF5miQ2HvAAU",
    },
    {
        city: "Baghdad",
        country: "Iraq",
        cityLong: "Baghdad, Iraq",
        citySlug: "baghdad-iraq",
        lat: 33.315241,
        lng: 44.3660671,
        timezone: "Asia/Baghdad",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UVHetP%0aJs-_NNHj]a#.8R,R+R*%ge-V@oz",
        googleMapsPlaceId: "ChIJk0GnoGd_VxURLG-xo9Kp7Z0",
    },
    {
        city: "Bangkok",
        country: "Thailand",
        cityLong: "Bangkok, Thailand",
        citySlug: "bangkok-thailand",
        lat: 13.7563309,
        lng: 100.5017651,
        timezone: "Asia/Bangkok",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UdFi7HR*IoWV?wjZM|bHT1oLWBj[NGays:f6",
        googleMapsPlaceId: "ChIJ82ENKDJgHTERIEjiXbIAAQE",
    },
    {
        city: "Beijing",
        country: "China",
        cityLong: "Beijing, China",
        citySlug: "beijing-china",
        lat: 39.904211,
        lng: 116.407395,
        timezone: "Asia/Shanghai",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U44V^4R3Mvt89bkCkDaJD4t8t8XA.AX9W9kD",
        googleMapsPlaceId: "ChIJuSwU55ZS8DURiqkPryBWYrk",
    },
    {
        city: "Beirut",
        country: "Lebanon",
        cityLong: "Beirut, Lebanon",
        citySlug: "beirut-lebanon",
        lat: 33.8937913,
        lng: 35.5017767,
        timezone: "Asia/Beirut",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UIEfvOtlw^WCt:W=EMWUBpOYn*soOGofNGRj",
        googleMapsPlaceId: "ChIJj6eAWCEXHxURtDaY6bqCkXI",
    },
    {
        city: "Canberra",
        country: "Australia",
        cityLong: "Canberra, Australia",
        citySlug: "canberra-australia",
        lat: -35.2801846,
        lng: 149.1310324,
        timezone: "Australia/Sydney",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UF9Qp~S1RiWXAO%1a$oM$KNM%LWBI8sqE2oc",
        googleMapsPlaceId: "ChIJuzQLsqNMFmsRcFlpp27qAAQ",
    },
    {
        city: "Dhaka",
        country: "Bangladesh",
        cityLong: "Dhaka, Bangladesh",
        citySlug: "dhaka-bangladesh",
        lat: 23.804093,
        lng: 90.4152376,
        timezone: "Asia/Dhaka",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UIA^Rl%LDiWE?ds.IrWXI{RjWZkCEVay%2oe",
        googleMapsPlaceId: "ChIJgWsCh7C4VTcRwgRZ3btjpY8",
    },
    {
        city: "Dubai",
        country: "UAE",
        cityLong: "Dubai, UAE",
        citySlug: "dubai-uae",
        lat: 25.2048493,
        lng: 55.2707828,
        timezone: "Asia/Dubai",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UnN0D7aLWWf6~Wafjsay9bW=j[a|D*ofWCj[",
        googleMapsPlaceId: "ChIJRcbZaklDXz4RYlEphFBu5r0",
    },
    {
        city: "Hanoi",
        country: "Vietnam",
        cityLong: "Hanoi, Vietnam",
        citySlug: "hanoi-vietnam",
        lat: 14.058324,
        lng: 108.277199,
        timezone: "Asia/Saigon",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UeFFp:M}Iqi^t:jbWXV?58t7xZRji]WXofof",
        googleMapsPlaceId: "ChIJXx5qc016FTERvmL-4smwO7A",
    },
    {
        city: "Hong Kong",
        country: "China",
        cityLong: "Hong Kong, China",
        citySlug: "hong-kong-china",
        lat: 22.3193039,
        lng: 114.1693611,
        timezone: "Asia/Hong_Kong",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UjDIz:WBS1xC-@NGSfjYK7jFs:WBE%bIj]WC",
        googleMapsPlaceId: "ChIJD5gyo-3iAzQRfMnq27qzivA",
    },
    {
        city: "Jakarta",
        country: "Indonesia",
        cityLong: "Jakarta, Indonesia",
        citySlug: "jakarta-indonesia",
        lat: -6.1944491,
        lng: 106.8229198,
        timezone: "Asia/Jakarta",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U78#Q@4m00~V0u#f^b9*roWtXot8x{nzD$nL",
        googleMapsPlaceId: "ChIJnUvjRenzaS4RoobX2g-_cVM",
    },
    {
        city: "Kabul",
        country: "Afghanistan",
        cityLong: "Kabul, Afghanistan",
        citySlug: "kabul-afghanistan",
        lat: 34.5553494,
        lng: 69.207486,
        timezone: "Asia/Kabul",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U?FH6NWAWCa|Y*WBWpjtK%ayj[ayI;s:oLj[",
        googleMapsPlaceId: "ChIJSW0ePExp0TgRKUQheDVH3-s",
    },
    {
        city: "Kathmandu",
        country: "Nepal",
        cityLong: "Kathmandu, Nepal",
        citySlug: "kathmandu-nepal",
        lat: 27.7172453,
        lng: 85.3239605,
        timezone: "Asia/Katmandu",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UHGH}49v4.tQ.TNct7s-1P%0%2NGyEWBROof",
        googleMapsPlaceId: "ChIJv6p7MIoZ6zkR6rGN8Rt8E7U",
    },
    {
        city: "Kuala Lumpur",
        country: "Malaysia",
        cityLong: "Kuala Lumpur, Malaysia",
        citySlug: "kuala-lumpur-malaysia",
        lat: 3.1319197,
        lng: 101.6840589,
        timezone: "Asia/Kuala_Lumpur",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UfB|aFs:NeoI%jofj[WBbwfkn$fkocWBRjj@",
        googleMapsPlaceId: "ChIJ0-cIvSo2zDERmWzYQPUfLiM",
    },
    {
        city: "Manila",
        country: "Philippines",
        cityLong: "Manila, Philippines",
        citySlug: "manila-philippines",
        lat: 14.5995124,
        lng: 120.9842195,
        timezone: "Asia/Manila",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UaFZEEoK$*WBu6s:offlIpR*s.oLIURjofoM",
        googleMapsPlaceId: "ChIJi8MeVwPKlzMRH8FpEHXV0Wk",
    },
    {
        city: "Melbourne",
        country: "Australia",
        cityLong: "Melbourne, Australia",
        citySlug: "melbourne-australia",
        lat: -37.8136276,
        lng: 144.9630576,
        timezone: "Australia/Melbourne",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UsDmzHt6tRWB%%oKoLayT1s:ayflNHRjRjWX",
        googleMapsPlaceId: "ChIJ90260rVG1moRkM2MIXVWBAQ",
    },
    {
        city: "Mumbai",
        country: "India",
        cityLong: "Mumbai, India",
        citySlug: "mumbai-india",
        lat: 19.0759837,
        lng: 72.8776559,
        timezone: "Asia/Calcutta",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UNC*CBx]NGaeCAazskofDhV@nhflrBoJayRk",
        googleMapsPlaceId: "ChIJwe1EZjDG5zsRaYxkjY_tpF0",
    },
    {
        city: "New Delhi",
        country: "India",
        cityLong: "New Delhi, India",
        citySlug: "new-delhi-india",
        lat: 28.6139391,
        lng: 77.2090212,
        timezone: "Asia/Calcutta",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U~K^?MoeRjoL~poeWYj?xuoft7ayM|azoJfR",
        googleMapsPlaceId: "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
    },
    {
        city: "Niseko",
        country: "Japan",
        cityLong: "Niseko, Japan",
        citySlug: "niseko-japan",
        lat: 42.8047856,
        lng: 140.6874494,
        timezone: "Asia/Tokyo",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UAEC,[tR%i0J00I9IUtR?wDhR+Rj-;xv%3Io",
        googleMapsPlaceId: "ChIJo1x_xZGuCl8RrJLxQh149XE",
    },
    {
        city: "Riyadh",
        country: "Saudi Arabia",
        cityLong: "Riyadh, Saudi Arabia",
        citySlug: "riyadh-saudi-arabia",
        lat: 24.7135517,
        lng: 46.6752957,
        timezone: "Asia/Riyadh",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U,CacCIVt7WCt:oLWBofObodaxaeR;odayfk",
        googleMapsPlaceId: "ChIJmZNIDYkDLz4R1Z_nmBxNl7o",
    },
    {
        city: "Seoul",
        country: "South Korea",
        cityLong: "Seoul, South Korea",
        citySlug: "seoul-south-korea",
        lat: 37.5518911,
        lng: 126.9917937,
        timezone: "Asia/Seoul",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UZHKwws:M{S5}@Nds.oc}=NeR.af^hWYs,jb",
        googleMapsPlaceId: "ChIJzzlcLQGifDURm_JbQKHsEX4",
    },
    {
        city: "Singapore",
        country: "Singapore",
        cityLong: "Singapore",
        citySlug: "singapore",
        lat: 1.352083,
        lng: 103.819836,
        timezone: "Asia/Singapore",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UAIg$S0100^k^--Vn$WBKm$z9tEL00?H^jIo",
        googleMapsPlaceId: "ChIJdZOLiiMR2jERxPWrUs9peIg",
    },
    {
        city: "Sydney",
        country: "Australia",
        cityLong: "Sydney, Australia",
        citySlug: "sydney-australia",
        lat: -33.8688197,
        lng: 151.2092955,
        timezone: "Australia/Sydney",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U#I$4$xujYWq~qjZWBj[xvs.f+axS$WBaxaz",
        googleMapsPlaceId: "ChIJP3Sa8ziYEmsRUKgyFmh9AQM",
    },
    {
        city: "Taipei",
        country: "Taiwan",
        cityLong: "Taipei, Taiwan",
        citySlug: "taipei-taiwan",
        lat: 25.0329694,
        lng: 121.5654177,
        timezone: "Asia/Taipei",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U6A9{FOFE1%2Km?H%1ad0L$*t7Io~CI.M{oz",
        googleMapsPlaceId: "ChIJmQrivHKsQjQR4MIK3c41aj8",
    },
    {
        city: "Tehran",
        country: "Iran",
        cityLong: "Tehran, Iran",
        citySlug: "tehran-iran",
        lat: 35.7218583,
        lng: 51.3346954,
        timezone: "Asia/Tehran",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UWHAt[IpJ7ay~ER*ayay0-xZodoL0gs:s:jt",
        googleMapsPlaceId: "ChIJ2dzzH0kAjj8RvCRwVnxps_A",
    },
    {
        city: "Tokyo",
        country: "Japan",
        cityLong: "Tokyo, Japan",
        citySlug: "tokyo-japan",
        lat: 35.6764225,
        lng: 139.650027,
        timezone: "Asia/Tokyo",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UDD,vI$yztIU}tvgsp$f3onoo@rwm+s;THI;",
        googleMapsPlaceId: "ChIJ51cu8IcbXWARiRtXIothAS4",
    },
    {
        city: "Vientiane",
        country: "Laos",
        cityLong: "Vientiane, Laos",
        citySlug: "vientiane-laos",
        lat: 17.9757058,
        lng: 102.6331035,
        timezone: "Asia/Vientiane",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "UMFiZ0tR4n%2?wt7-pbF?bR%M{WB%MWBIUWA",
        googleMapsPlaceId: "ChIJIXvtBoZoJDER3-7BGIaxkx8",
    },
    {
        city: "Wellington",
        country: "New Zealand",
        cityLong: "Wellington, New Zealand",
        citySlug: "wellington-new-zealand",
        lat: -41.2923814,
        lng: 174.7787463,
        timezone: "Pacific/Auckland",
        region: "APAC",
        regionSlug: "apac",
        blurHash: "U;K]ZKsmj]jZ}skCofj[%3jZWVfQIqj]a#fQ",
        googleMapsPlaceId: "ChIJy3TpSfyxOG0RcLQTomPvAAo",
    },
    {
        city: "Montreal",
        country: "Canada",
        cityLong: "Montreal, Canada",
        citySlug: "montreal-canada",
        lat: 45.5018869,
        lng: -73.56739189999999,
        timezone: "America/Toronto",
        region: "Canada",
        regionSlug: "canada",
        blurHash: "UI6]2|WYR4s:L4bbZ~f6JCt6n$WCxBWBogbH",
        googleMapsPlaceId: "ChIJDbdkHFQayUwR7-8fITgxTmU",
    },
    {
        city: "Ottawa",
        country: "Canada",
        cityLong: "Ottawa, Canada",
        citySlug: "ottawa-canada",
        lat: 45.4215296,
        lng: -75.69719309999999,
        timezone: "America/Toronto",
        region: "Canada",
        regionSlug: "canada",
        blurHash: "UNG,3GxuoKj].AWAWqaex]t8oIbIRNWAayaz",
        googleMapsPlaceId: "ChIJrxNRX7IFzkwR7RXdMeFRaoo",
    },
    {
        city: "Saskatoon",
        country: "Canada",
        cityLong: "Saskatoon, Canada",
        citySlug: "saskatoon-canada",
        lat: 52.157902,
        lng: -106.6701577,
        timezone: "America/Regina",
        region: "Canada",
        regionSlug: "canada",
        blurHash: "UgH-r*=_NFof_4xZWAoL5YNIjGWX57V{jZR*",
        googleMapsPlaceId: "ChIJK5ntR7_2BFMRkCZ3lTKeBAU",
    },
    {
        city: "Toronto",
        country: "Canada",
        cityLong: "Toronto, Canada",
        citySlug: "toronto-canada",
        lat: 43.653226,
        lng: -79.3831843,
        timezone: "America/Toronto",
        region: "Canada",
        regionSlug: "canada",
        blurHash: "UMI4^h?wbwj?*0%Mx]WX01NHx^WV4TIUofa}",
        googleMapsPlaceId: "ChIJpTvG15DL1IkRd8S0KlBVNTI",
    },
    {
        city: "Vancouver",
        country: "Canada",
        cityLong: "Vancouver, Canada",
        citySlug: "vancouver",
        lat: 49.2827291,
        lng: -123.1207375,
        timezone: "America/Vancouver",
        region: "Canada",
        regionSlug: "canada",
        blurHash: "UUG9KgD%t5Ne.Te,WBWXESr=RkR+IVogoJoe",
        googleMapsPlaceId: "ChIJs0-pQ_FzhlQRi_OBm-qWkbs",
    },
    {
        city: "Bogota",
        country: "Colombia",
        cityLong: "Bogota, Colombia",
        citySlug: "bogota-colombia",
        lat: 4.710988599999999,
        lng: -74.072092,
        timezone: "America/Bogota",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UKFs6~ITD%jETz9Fofof?wbHoJV@%gtRWCR+",
        googleMapsPlaceId: "ChIJKcumLf2bP44RFDmjIFVjnSM",
    },
    {
        city: "Brasilia",
        country: "Brazil",
        cityLong: "Brasilia, Brazil",
        citySlug: "brasilia-brazil",
        lat: -15.7975154,
        lng: -47.89188739999999,
        timezone: "America/Sao_Paulo",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UJACV:tSI9az00bc%Mj[l:RiM_f6.Ts.ozay",
        googleMapsPlaceId: "ChIJdeKa3xg9WpMRJEp1aeRwhHM",
    },
    {
        city: "Buenos Aires",
        country: "Argentina",
        cityLong: "Buenos Aires, Argentina",
        citySlug: "buenos-aires-argentina",
        lat: -34.6036844,
        lng: -58.3815591,
        timezone: "America/Buenos_Aires",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "URN0xL?bD*Ri_Nxu9ZadE7t7RPj@IvWBS5Rl",
        googleMapsPlaceId: "ChIJvQz5TjvKvJURh47oiC6Bs6A",
    },
    {
        city: "Cancun",
        country: "Mexico",
        cityLong: "Cancun, Mexico",
        citySlug: "cancun-mexico",
        lat: 21.161908,
        lng: -86.8515279,
        timezone: "America/Cancun",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UUCt%:rW9ZOY.TNGt6so-=WWoJj?tRWBoJbH",
        googleMapsPlaceId: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
    },
    {
        city: "Guadalajara",
        country: "Mexico",
        cityLong: "Guadalajara, Mexico",
        citySlug: "guadalajara",
        lat: 20.6751707,
        lng: -103.3473385,
        timezone: "America/Mexico_City",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UwIOnhRiM_M{~pV@WCRjx^aeWVayNHjsWBof",
        googleMapsPlaceId: "ChIJm9MvtYyxKIQRUFeGvwKTPdY",
    },
    {
        city: "La Paz",
        country: "Bolivia",
        cityLong: "La Paz, Bolivia",
        citySlug: "la-paz-bolivia",
        lat: -16.489689,
        lng: -68.11929359999999,
        timezone: "America/La_Paz",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UDHn1*%1E2ae7hE2s:xtOtE1t7-p_Msosoof",
        googleMapsPlaceId: "ChIJD6T1BArfXpERs4pFtHb821c",
    },
    {
        city: "Lima",
        country: "Peru",
        cityLong: "Lima, Peru",
        citySlug: "lima-peru",
        lat: -12.0463731,
        lng: -77.042754,
        timezone: "America/Lima",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UEDd0NTfbw$v0Isri]oIMdaKnLS7rWM}tSWZ",
        googleMapsPlaceId: "ChIJxz7uGfbFBZERSi5FzLlsIBQ",
    },
    {
        city: "Medellin",
        country: "Colombia",
        cityLong: "Medellin, Colombia",
        citySlug: "medellin-colombia",
        lat: 6.2476376,
        lng: -75.56581530000001,
        timezone: "America/Bogota",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UxEzQNnNsAWB%%jXRiR-tRoej[WrRPs.oJae",
        googleMapsPlaceId: "ChIJBa0PuN8oRI4RVju1x_x8E0I",
    },
    {
        city: "Mexico City",
        country: "Mexico",
        cityLong: "Mexico City, Mexico",
        citySlug: "mexico-city",
        lat: 19.4326077,
        lng: -99.133208,
        timezone: "America/Mexico_City",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UUHxsaWV4oay%%fkofWVElj[%Mj[o~oej[of",
        googleMapsPlaceId: "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
    },
    {
        city: "Monterrey",
        country: "Mexico",
        cityLong: "Monterrey, Mexico",
        citySlug: "monterrey-mexico",
        lat: 25.6866142,
        lng: -100.3161126,
        timezone: "America/Monterrey",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UMG?|w$yNKaL}]oKbFjs0;NKxWkAF2oJn%WC",
        googleMapsPlaceId: "ChIJ9fg3tDGVYoYRlJjIasrT06M",
    },
    {
        city: "Montevideo",
        country: "Uruguay",
        cityLong: "Montevideo, Uruguay",
        citySlug: "montevideo-uruguay",
        lat: -34.9055016,
        lng: -56.1851147,
        timezone: "America/Montevideo",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UkGSDiofocof~qs:oLayx]oeWVj[%gj[WCj[",
        googleMapsPlaceId: "ChIJ0_c7xv-An5URmexbNS4bMms",
    },
    {
        city: "Nassau",
        country: "Bahamas",
        cityLong: "Nassau, Bahamas",
        citySlug: "nassau-bahamas",
        lat: 25.0443312,
        lng: -77.3503609,
        timezone: "America/Nassau",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UJ9S-,#Nk7wb%Ps6adWTK-TCi|SP-.oNbuno",
        googleMapsPlaceId: "ChIJyduBuZl8L4kR0lBeSNMB7yo",
    },
    {
        city: "Oaxaca",
        country: "Mexico",
        cityLong: "Oaxaca, Mexico",
        citySlug: "oaxaca-mexico",
        lat: 17.0731842,
        lng: -96.7265889,
        timezone: "America/Mexico_City",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UULD.O00m+ivTh-p$eRPK,%gaIS5ERS~xatR",
        googleMapsPlaceId: "ChIJsdkm30kix4URO_zfV3aniKw",
    },
    {
        city: "Puebla",
        country: "Mexico",
        cityLong: "Puebla, Mexico",
        citySlug: "puebla-mexico",
        lat: 19.0414398,
        lng: -98.2062727,
        timezone: "America/Mexico_City",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "U9DSdoT04.WX3GW=wHfkrpnORkjtIrnhWXWB",
        googleMapsPlaceId: "ChIJO3q8Xr3Az4URla2U5B1Gpkg",
    },
    {
        city: "Queretaro",
        country: "Mexico",
        cityLong: "Queretaro, Mexico",
        citySlug: "queretaro-mexico",
        lat: 20.5887932,
        lng: -100.3898881,
        timezone: "America/Mexico_City",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "ULFZgNXSK8xA0bxtxCaxvKM|aIS*ISWCs;Rj",
        googleMapsPlaceId: "ChIJVZJb3I9b04URL4MbVqqUsJc",
    },
    {
        city: "Quito",
        country: "Ecuador",
        cityLong: "Quito, Ecuador",
        citySlug: "quito-ecuador",
        lat: -0.1806532,
        lng: -78.4678382,
        timezone: "America/Guayaquil",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UfE{|lR+bIjuKnxtR,ayb|a~flWDRoofWBoz",
        googleMapsPlaceId: "ChIJn3xCAkCa1ZERclXvWOGRuUQ",
    },
    {
        city: "Saint John_s",
        country: "Antigua and Barbuda",
        cityLong: "Saint John_s, Antigua and Barbuda",
        citySlug: "saint-john_s-antigua-and-barbuda",
        lat: 17.1274104,
        lng: -61.84677199999999,
        timezone: "America/Antigua",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "ULDS][xtxCt7u6-oxYe:ERxYt7t7xan#ozR+",
        googleMapsPlaceId: "ChIJpRuO60uSEowRTzfbYy8SRnw",
    },
    {
        city: "San Juan",
        country: "Puerto Rico",
        cityLong: "San Juan, Puerto Rico",
        citySlug: "san-juan-puerto-rico",
        lat: 18.4670588,
        lng: -66.1184593,
        timezone: "America/Puerto_Rico",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "U-Ho:y$yogoK?^xaoIofW=ofoKWBM|WBbHj@",
        googleMapsPlaceId: "ChIJbxlo4m9oA4wR3FqTXA9_a60",
    },
    {
        city: "Santiago",
        country: "Chile",
        cityLong: "Santiago, Chile",
        citySlug: "santiago-chile",
        lat: -33.4488897,
        lng: -70.6692655,
        timezone: "America/Santiago",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "U~Fs-{Rko1oL.TWBjZj[XTj[ayfRNGoffkay",
        googleMapsPlaceId: "ChIJL68lBEHFYpYRMQkPQDzVdYQ",
    },
    {
        city: "Santo Domingo",
        country: "Republica Dominicana",
        cityLong: "Santo Domingo, Republica Dominicana",
        citySlug: "santo-domingo-republica-dominicana",
        lat: 18.4626178,
        lng: -69.93609239999999,
        timezone: "America/Santo_Domingo",
        region: "LATAM & Caribbean",
        regionSlug: "latam-caribbean",
        blurHash: "UMJt^,xt8w.8.Tf+MwW=ozRPRPaxMxaftRV@",
        googleMapsPlaceId: "ChIJq6V-EPGJr44RZMEVJ7iHxdY",
    },
    {
        city: "Asheville",
        country: "USA",
        cityLong: "Asheville, NC",
        citySlug: "asheville-nc",
        lat: 35.5950581,
        lng: -82.5514869,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UXIz-YIVI;oe}=jds:oL^gRloLV@^gRjaxt7",
        googleMapsPlaceId: "ChIJCW8PPKmMWYgRXTo0BsEx75Q",
    },
    {
        city: "Atlanta",
        country: "USA",
        cityLong: "Atlanta, GA",
        citySlug: "atlanta-ga",
        lat: 33.748752,
        lng: -84.38768449999999,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UjCs:fbINGazyZWEniWVT2ays.ofIss:WWoL",
        googleMapsPlaceId: "ChIJjQmTaV0E9YgRC2MLmS_e_mY",
    },
    {
        city: "Austin",
        country: "USA",
        cityLong: "Austin, TX",
        citySlug: "austin-tx",
        lat: 30.267153,
        lng: -97.7430608,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UlE|VhozxtV[%%s,s,WDIpWWoej]D*R*s,ae",
        googleMapsPlaceId: "ChIJLwPMoJm1RIYRetVp1EtGm10",
    },
    {
        city: "Beverly Hills",
        country: "USA",
        cityLong: "Beverly Hills, CA",
        citySlug: "beverly-hills-ca",
        lat: 34.0736204,
        lng: -118.4003563,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "USGSZ4IrDikDNHxuaKWY?wo#V=WXx^bIROog",
        googleMapsPlaceId: "ChIJq0fR1gS8woAR0R4I_XnDx9Y",
    },
    {
        city: "Boston",
        country: "USA",
        cityLong: "Boston, MA",
        citySlug: "boston-ma",
        lat: 42.3600825,
        lng: -71.0588801,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U-CQ}#jua$f6tpa#afj[IWjZWUfkIBjZj[a}",
        googleMapsPlaceId: "ChIJGzE9DS1l44kRoOhiASS_fHg",
    },
    {
        city: "Charleston",
        country: "USA",
        cityLong: "Charleston, SC",
        citySlug: "charleston-sc",
        lat: 32.7764749,
        lng: -79.93105120000001,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UfDJ#aTf%1S4t:OangbFObWBRif+RkV@t7kX",
        googleMapsPlaceId: "ChIJdySo3EJ6_ogRa-zhruD3-jU",
    },
    {
        city: "Charlotte",
        country: "USA",
        cityLong: "Charlotte, NC",
        citySlug: "charlotte-nc",
        lat: 35.2270869,
        lng: -80.8431267,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U6AvtV?arqSh009akXWC~B=|WBnhRj9tWBoz",
        googleMapsPlaceId: "ChIJgRo4_MQfVIgRZNFDv-ZQRog",
    },
    {
        city: "Chicago",
        country: "USA",
        cityLong: "Chicago, IL",
        citySlug: "chicago",
        lat: 41.8781136,
        lng: -87.6297982,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UgEp7;W=WCWV_4kBjtWq?bj[aefQ?GW=jZoK",
        googleMapsPlaceId: "ChIJ7cv00DwsDogRAMDACa2m4K8",
    },
    {
        city: "Cincinnati",
        country: "USA",
        cityLong: "Cincinnati, OH",
        citySlug: "cincinnati-oh",
        lat: 39.1031182,
        lng: -84.5120196,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UeFZ1nnOxu$i_Mj[niW;x]off6kCS~xZofs.",
        googleMapsPlaceId: "ChIJ-SE43rFRQIgRF5PA5It--2k",
    },
    {
        city: "Columbus",
        country: "USA",
        cityLong: "Columbus, OH",
        citySlug: "columbus-oh",
        lat: 39.9611755,
        lng: -82.99879419999999,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UdHCWRIpIVbI.TIoV@WBMxsmjFV@RPj?oLj[",
        googleMapsPlaceId: "ChIJcd6QucGJOIgRM7Wxz_hmMuQ",
    },
    {
        city: "Dallas",
        country: "USA",
        cityLong: "Dallas, TX",
        citySlug: "dallas-tx",
        lat: 32.7766642,
        lng: -96.79698789999999,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UM8W].xbaen#-@oIjboMbzf,a{WUI=WUWTWX",
        googleMapsPlaceId: "ChIJS5dFe_cZTIYRj2dH9qSb7Lk",
    },
    {
        city: "Denver",
        country: "USA",
        cityLong: "Denver, CO",
        citySlug: "denver-co",
        lat: 39.7392358,
        lng: -104.990251,
        timezone: "America/Denver",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UgD1EjtlRkV@KUafofkCIwWYaKa#Q-WBoIoe",
        googleMapsPlaceId: "ChIJzxcfI6qAa4cR1jaKJ_j0jhE",
    },
    {
        city: "Detroit",
        country: "USA",
        cityLong: "Detroit, MI",
        citySlug: "detroit-mi",
        lat: 42.331427,
        lng: -83.0457538,
        timezone: "America/Detroit",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U38NLctM00Sm0JWZ%NRh00a1%M$_~XbXMwo$",
        googleMapsPlaceId: "ChIJdR3LEAHKJIgR0sS5NU6Gdlc",
    },
    {
        city: "El Paso",
        country: "USA",
        cityLong: "El Paso, TX",
        citySlug: "el-paso-tx",
        lat: 31.7618778,
        lng: -106.4850217,
        timezone: "America/Denver",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U?LqFPslj[oL~qR+WVWXX9jZoej@M_j[WWaz",
        googleMapsPlaceId: "ChIJaTv-xYs_54YRIgKdq-OEkeM",
    },
    {
        city: "Fort Lauderdale",
        country: "USA",
        cityLong: "Fort Lauderdale, FL",
        citySlug: "fort-lauderdale-fl",
        lat: 26.1224386,
        lng: -80.13731740000001,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "Ua9]1=V@IAt6t:oIV@WVRjWBV@j]M_W=a#ay",
        googleMapsPlaceId: "ChIJ9cr6ICcB2YgRvo6_QHW-AnY",
    },
    {
        city: "Fort Worth",
        country: "USA",
        cityLong: "Fort Worth, TX",
        citySlug: "fort-worth-tx",
        lat: 32.7554883,
        lng: -97.3307658,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UeI53$RjR%Si_NWBj]oex^ofWXjF%MjuV@Rj",
        googleMapsPlaceId: "ChIJrQfILRJuToYRvaxp3fiLr6Q",
    },
    {
        city: "Houston",
        country: "USA",
        cityLong: "Houston, TX",
        citySlug: "houston-tx",
        lat: 29.7604267,
        lng: -95.3698028,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U6Bf03~C5,5Q1ANH,@$*Dk0zO9xZve^5X4Nt",
        googleMapsPlaceId: "ChIJAYWNSLS4QIYROwVl894CDco",
    },
    {
        city: "Jacksonville",
        country: "USA",
        cityLong: "Jacksonville, FL",
        citySlug: "jacksonville-fl",
        lat: 30.3321838,
        lng: -81.65565099999999,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UqEpf%Rks,a#.TNbjsayElbHf6j@E1s.f6az",
        googleMapsPlaceId: "ChIJ66_O8Ra35YgR4sf8ljh9zcQ",
    },
    {
        city: "Kansas City",
        country: "USA",
        cityLong: "Kansas City, MO",
        citySlug: "kansas-city-mo",
        lat: 39.0997265,
        lng: -94.5785667,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UsFFQ}%1jZoe_4t6ayoL-:WUR*a#xsR*aza#",
        googleMapsPlaceId: "ChIJl5npr173wIcRolGqauYlhVU",
    },
    {
        city: "Las Vegas",
        country: "USA",
        cityLong: "Las Vegas, NV",
        citySlug: "las-vegas-nv",
        lat: 36.171563,
        lng: -115.1391009,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U5Ace=588wE,00^*~oIU6]Z$N4~ANItM9ZIX",
        googleMapsPlaceId: "ChIJ0X31pIK3voARo3mz1ebVzDo",
    },
    {
        city: "Los Angeles",
        country: "USA",
        cityLong: "Los Angeles, CA",
        citySlug: "los-angeles-ca",
        lat: 34.0522342,
        lng: -118.2436849,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "L-KUvMozt7j?_4oejZj[n$RjRjWC",
        googleMapsPlaceId: "ChIJE9on3F3HwoAR9AhGJW_fL-I",
    },
    {
        city: "Louisville",
        country: "USA",
        cityLong: "Louisville, KY",
        citySlug: "louisville-ky",
        lat: 38.2526647,
        lng: -85.7584557,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UeJHp#NHR*Rk_4s.WBayEnxZWCoLIVNHoLof",
        googleMapsPlaceId: "ChIJEdVbsxoLaYgRMv1xICi009Q",
    },
    {
        city: "Memphis",
        country: "USA",
        cityLong: "Memphis, TN",
        citySlug: "memphis-tn",
        lat: 35.1495343,
        lng: -90.0489801,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UN5~eSS2n#bIX=oIV?jZMyf5WCaxitW=ozay",
        googleMapsPlaceId: "ChIJRZdD6h5-1YcR_rYaYBXzk9E",
    },
    {
        city: "Miami",
        country: "USA",
        cityLong: "Miami, FL",
        citySlug: "miami-fl",
        lat: 25.7616798,
        lng: -80.1917902,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UjK-,#MxR+t6_Nslayoeb{s.RiaeITo0jYay",
        googleMapsPlaceId: "ChIJEcHIDqKw2YgRZU-t3XHylv8",
    },
    {
        city: "Minneapolis",
        country: "USA",
        cityLong: "Minneapolis, MN",
        citySlug: "minneapolis-mn",
        lat: 44.977753,
        lng: -93.2650108,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UaDSE_ENoIay~WI=s.WB%MS5s:WBS5s:jZjt",
        googleMapsPlaceId: "ChIJvbt3k5Azs1IRB-56L4TJn5M",
    },
    {
        city: "NYC",
        country: "USA",
        cityLong: "NYC, NY",
        citySlug: "nyc",
        lat: 40.7127753,
        lng: -74.0059728,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UfDvpBNHaxoL.TWVaya#AJsmWCa#E1oKazoL",
        googleMapsPlaceId: "ChIJOwg_06VPwokRYv534QaPC8g",
    },
    {
        city: "Nashville",
        country: "USA",
        cityLong: "Nashville, TN",
        citySlug: "nashville-tn",
        lat: 36.1626638,
        lng: -86.7816016,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UdIy,vI=Sg$$}@n+xGWV^Ps.NIxDoen%WCfi",
        googleMapsPlaceId: "ChIJPZDrEzLsZIgRoNrpodC5P30",
    },
    {
        city: "Oklahoma City",
        country: "USA",
        cityLong: "Oklahoma City, OK",
        citySlug: "oklahoma-city",
        lat: 35.4675602,
        lng: -97.5164276,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U[I=ofxZRjoe_Ns:WBj[OFWCWVbHE1ayaza|",
        googleMapsPlaceId: "ChIJgdL4flSKrYcRnTpP0XQSojM",
    },
    {
        city: "Omaha",
        country: "USA",
        cityLong: "Omaha, NE",
        citySlug: "omaha-ne",
        lat: 41.2565369,
        lng: -95.9345034,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UhIYX%nN%MRj.T%2ocWFcEs:RikBNdaKWEof",
        googleMapsPlaceId: "ChIJ7fwMtciNk4cRBLY3rk9NQkY",
    },
    {
        city: "Orlando",
        country: "USA",
        cityLong: "Orlando, FL",
        citySlug: "orlando-fl",
        lat: 28.5383832,
        lng: -81.3789269,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U87na*Q+r:o{KBjCWBn%01tQkYV[;ap0t7bY",
        googleMapsPlaceId: "ChIJd7zN_thz54gRnr-lPAaywwo",
    },
    {
        city: "Philadelphia",
        country: "USA",
        cityLong: "Philadelphia, PA",
        citySlug: "philadelphia-pa",
        lat: 39.9525839,
        lng: -75.1652215,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U-Jto3%1aebG~pt7WAof.7W=WBfktSR+fkj[",
        googleMapsPlaceId: "ChIJ60u11Ni3xokRwVg-jNgU9Yk",
    },
    {
        city: "Phoenix",
        country: "USA",
        cityLong: "Phoenix, AZ",
        citySlug: "phoenix-az",
        lat: 33.4483771,
        lng: -112.0740373,
        timezone: "America/Phoenix",
        region: "USA",
        regionSlug: "usa",
        blurHash: "Ub9%#*oIa#bIpMslWXbIXUR*jsoLIoWCj[j@",
        googleMapsPlaceId: "ChIJy3mhUO0SK4cRrBtKNfjHaYw",
    },
    {
        city: "Pittsburgh",
        country: "USA",
        cityLong: "Pittsburgh, PA",
        citySlug: "pittsburgh-pa",
        lat: 40.44062479999999,
        lng: -79.9958864,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "Ut85mLf,Rkjtpff5aej[S+jXjsazXVbIaxax",
        googleMapsPlaceId: "ChIJA4UGSG_xNIgRNBuiWqEV-Y0",
    },
    {
        city: "Raleigh",
        country: "USA",
        cityLong: "Raleigh, NC",
        citySlug: "raleigh-nc",
        lat: 35.7795897,
        lng: -78.6381787,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "URGaqbI;xER+_4NHWUa|0}niR*so,onjs:WC",
        googleMapsPlaceId: "ChIJ9-BRny9arIkRrfARilK2kGc",
    },
    {
        city: "Salt Lake City",
        country: "USA",
        cityLong: "Salt Lake City, UT",
        citySlug: "salt-lake-city-ut",
        lat: 40.7607793,
        lng: -111.8910474,
        timezone: "America/Denver",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U~G,bMNHj?ay?wR*fQfQxBj[a#jtniofWVj[",
        googleMapsPlaceId: "ChIJ7THRiJQ9UocRyjFNSKC3U1s",
    },
    {
        city: "San Antonio",
        country: "USA",
        cityLong: "San Antonio, TX",
        citySlug: "san-antonio-tx",
        lat: 29.4251905,
        lng: -98.4945922,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UwKeAotRozjF_NafjtaySOaKe.kCs,f6WBkC",
        googleMapsPlaceId: "ChIJrw7QBK9YXIYRvBagEDvhVgg",
    },
    {
        city: "San Diego",
        country: "USA",
        cityLong: "San Diego, CA",
        citySlug: "san-diego-ca",
        lat: 32.715738,
        lng: -117.1610838,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UpJHzIofkCof~qfkWBayNGRjaef6IVayf6oL",
        googleMapsPlaceId: "ChIJSx6SrQ9T2YARed8V_f0hOg0",
    },
    {
        city: "San Francisco",
        country: "USA",
        cityLong: "San Francisco, CA",
        citySlug: "san-francisco-ca",
        lat: 37.7749295,
        lng: -122.4194155,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U.JI6Io}n$of.Aj[j@ayE.V@oej[E3WBofae",
        googleMapsPlaceId: "ChIJIQBpAG2ahYAR_6128GcTUEo",
    },
    {
        city: "San Mateo",
        country: "USA",
        cityLong: "San Mateo, CA",
        citySlug: "san-mateo-ca",
        lat: 37.5629917,
        lng: -122.3255254,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "Uf7fiVj[jsj[lVafj[a#IqV@j[ayR5n$fkf6",
        googleMapsPlaceId: "ChIJRVWp72Cej4ARpxvMLfT8jv0",
    },
    {
        city: "Seattle",
        country: "USA",
        cityLong: "Seattle, WA",
        citySlug: "seattle-wa",
        lat: 47.6061389,
        lng: -122.3328481,
        timezone: "America/Los_Angeles",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UpFro4jYRjofx|fljsj[4?kCj?WCMyj@WVay",
        googleMapsPlaceId: "ChIJVTPokywQkFQRmtVEaUZlJRA",
    },
    {
        city: "St. Louis",
        country: "USA",
        cityLong: "St. Louis, MO",
        citySlug: "st-louis-mo",
        lat: 38.6270025,
        lng: -90.19940419999999,
        timezone: "America/Chicago",
        region: "USA",
        regionSlug: "usa",
        blurHash: "LLCG12x]IoWBPEkDaKWV9aRQoKj[",
        googleMapsPlaceId: "ChIJ-Y7t-qm02IcRW-C7IsrqOb4",
    },
    {
        city: "Tampa",
        country: "USA",
        cityLong: "Tampa, FL",
        citySlug: "tampa-fl",
        lat: 27.9516896,
        lng: -82.45875269999999,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "U78zcNn.IuR.t:ozf*of0joaxVof$kV{Rkae",
        googleMapsPlaceId: "ChIJ4dG5s4K3wogRY7SWr4kTX6c",
    },
    {
        city: "Washington D.C.",
        country: "USA",
        cityLong: "Washington, D.C",
        citySlug: "washington-d.c",
        lat: 38.9071923,
        lng: -77.0368707,
        timezone: "America/New_York",
        region: "USA",
        regionSlug: "usa",
        blurHash: "UKGcJ,D4R*wHCATKnhngDhb{t7jEu%SjkXae",
        googleMapsPlaceId: "ChIJW-T2Wt7Gt4kRKl2I1CJFUsI",
    },
];

export const citiesMap: { [key: string]: (typeof cities)[0] } = Object.assign(
    {},
    ...cities.map((c) => ({ [c.city]: c })),
);

export const vibes = [
    {
        name: "coffee-shop-1",
        blurHash: "UAG8ZV=v;M$$_NRj^k9FnNRPNuxtE2EMw^%2",
    },
    {
        name: "coffee-shop-2",
        blurHash: "UPKUJ_?aR5M{~pNGof%28_t7NGMxV?s.Rka{",
    },
    {
        name: "coffee",
        blurHash: "U8D+PQxt01Nb_M$*ODD*57xu?H9at8%2-:-n",
    },
    {
        name: "coworking",
        blurHash: "UtF?U_uPPVo~-UbbI;f6t7ayWVaeWVj[j[oL",
    },
    {
        name: "dinner-casual",
        blurHash: "UUGI4R%MI:%2~VMxRiWBbwM{afWXW=jabcbb",
    },
    {
        name: "dinner-formal",
        blurHash: "USHUtZ?ax]R-~qs:%MRkyEo#xu%2t7R*oft7",
    },
    {
        name: "hanging-out",
        blurHash: "UWLzN%~W?GMycatlIAw[xFi^MxM|IqjZoLbb",
    },
    {
        name: "happy-hour",
        blurHash: "UIEKx;~A9]M{1Ot7$%NH^Nt5R,$%K5S$ofWX",
    },
    {
        name: "hike-1",
        blurHash: "UZK]_Q0h4p?s};E3R:%L4:n$%Loy-otQRjnO",
    },
    {
        name: "hike-2",
        blurHash: "UVH.H3X9IAWV_N%MMxozNdxue.NGV[bGt7Rj",
    },
    {
        name: "networking",
        blurHash: "UVIhgJIUD%M|~px[IU%MozV@xuofWURPt8WB",
    },
    {
        name: "park",
        blurHash: "UqH_f3MxRkxu~qIUoIoz_3aeofof%Ns.WVae",
    },
    {
        name: "party",
        blurHash: "UC8.xHJ2bbno=kEuogwPS~J3ogwPX7jFs;S0",
    },
    {
        name: "poker",
        blurHash: "UODcUHAZbHI:_NnORkNa%NRPNGWBWYIoNGs:",
    },
    {
        name: "talk-1",
        blurHash: "UHA-9f?FM_M_*JRPROWTUHM|WAf#%~niRiX5",
    },
    {
        name: "talk-2",
        blurHash: "UC5;^bneaGocJIabW7bdIlW?t8WAxAsqWBoI",
    },
    {
        name: "talk-3",
        blurHash: "UJD[2w}=S4xZxt-o-TWBI:s.X8S2I=aexDs.",
    },
    {
        name: "talk-4",
        blurHash: "UeIEU;RjgNt6.mt7oLofpwjusoae-;aKNHR*",
    },
    {
        name: "yoga-1",
        blurHash: "U$OfxuJAxsRj_Ns;a$jrbdt5WBaxROW?e.kC",
    },
    {
        name: "yoga-2",
        blurHash: "UIKm9ZElt:zp0J9txst+0e-6m*5-bCo~$*vg",
    },
];

export const getVibeImage = (name: string | undefined = undefined) => {
    const elem = name
        ? vibes.find((e) => e.name === name)
        : vibes[Math.floor(Math.random() * vibes.length)];
    if (!elem) throw new Error("No vibe images");
    return {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/city/vibes/${elem.name}.webp`,
        imageBlurhash: elem?.blurHash,
    };
};

export const getRandomVibeImage = (hash: string) => {
    // Create a simple hash function to get consistent index based on input string
    let hashValue = 0;
    for (let i = 0; i < hash.length; i++) {
        const char = hash.charCodeAt(i);
        hashValue = (hashValue << 5) - hashValue + char;
        hashValue = hashValue & hashValue; // Convert to 32-bit integer
    }

    // Get consistent index within vibes array bounds
    const index = Math.abs(hashValue) % vibes.length;
    const elem = vibes[index];

    if (!elem) throw new Error("No vibe images");

    return {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/city/vibes/${elem.name}.webp`,
        imageBlurhash: elem?.blurHash,
    };
};
